/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-fc63c737.mjs';
import { toRefs, computed, ref, watchEffect } from 'vue';
import { d as dayjs } from '../../_chunks/dep-99a0abba.mjs';
import { getDefaultFormat, formatTime, formatDate, isValidDate } from '../../_common/js/date-picker/format.mjs';
import useVModel from '../../hooks/useVModel.mjs';
import { extractTimeFormat } from '../../_common/js/date-picker/utils.mjs';
import '../../_chunks/dep-2a2a0e63.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_common/js/log/index.mjs';
import '../../_common/js/log/log.mjs';
import '../../_chunks/dep-b011b919.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-576ed755.mjs';
import '../../_chunks/dep-63c5b255.mjs';
import '../../_chunks/dep-06221fe2.mjs';
import '../../_chunks/dep-0fa7026c.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-b9d74a58.mjs';
import '../../_chunks/dep-31dc9d09.mjs';
import '../../_chunks/dep-94585de3.mjs';

function useSingleValue(props) {
  var _toRefs = toRefs(props),
    valueFromProps = _toRefs.value,
    modelValue = _toRefs.modelValue;
  var _useVModel = useVModel(valueFromProps, modelValue, props.defaultValue, props.onChange),
    _useVModel2 = _slicedToArray(_useVModel, 2),
    value = _useVModel2[0],
    onChange = _useVModel2[1];
  var formatRef = computed(function () {
    return getDefaultFormat({
      mode: props.mode,
      format: props.format,
      enableTimePicker: props.enableTimePicker
    });
  });
  if (props.enableTimePicker) {
    if (!extractTimeFormat(formatRef.value.format)) console.error("format: ".concat(formatRef.value.format, " \u4E0D\u89C4\u8303\uFF0C\u5305\u542B\u65F6\u95F4\u9009\u62E9\u5FC5\u987B\u8981\u6709\u65F6\u95F4\u683C\u5F0F\u5316 HH:mm:ss"));
  }
  var time = ref(formatTime(value.value, formatRef.value.timeFormat));
  var month = ref(dayjs(value.value).month() || new Date().getMonth());
  var year = ref(dayjs(value.value).year() || new Date().getFullYear());
  var cacheValue = ref(formatDate(value.value, {
    format: formatRef.value.format
  }));
  watchEffect(function () {
    if (!value.value) {
      cacheValue.value = "";
      return;
    }
    if (!isValidDate(value.value, formatRef.value.format)) return;
    cacheValue.value = formatDate(value.value, {
      format: formatRef.value.format
    });
    time.value = formatTime(value.value, formatRef.value.timeFormat);
  });
  return {
    year: year,
    month: month,
    value: value,
    time: time,
    cacheValue: cacheValue,
    onChange: onChange
  };
}

export { useSingleValue as default };
//# sourceMappingURL=useSingleValue.mjs.map
